import React from 'react'

import { Health } from 'components/Icons'
import { SegmentGroup } from 'components/Common'

export const MyHealth = () => {
  return (
    <SegmentGroup
      icon={<Health width={30} height={30} />}
      title='My Health'
      description='View your medical record, test results, and refill prescriptions'
      linkTo='/myHealth'
      linkText='View >'
    />
  )
}
